module.exports = __webpack_public_path__ + "img/system3.eebdbd78.png";